export * from "./api";
export * from "./async-actions";

export function addUrlParameter(name: string, value: string): string {
  return `${name}=${encodeURI(value)}`;
}
